import React from 'react';
import PropTypes from 'prop-types';

import { Colors, FontSizes } from '../Theme';

const FieldGroup = ({ children, contained, label, description }) => {
  const styles = {
    label: {
      fontSize: FontSizes.REGULAR,
      color: Colors.GRAY.hex,
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'space-between'
    },
    description: {
      fontSize: FontSizes.SMALL,
      color: Colors.GRAY.hex,
      marginBottom: 10,
      fontStyle: 'italic'
    },
    content: {
      padding: contained ? 20 : '0px 0px 0px 10px',
      background: contained ? '#f5f5f5' : '#fff',
      marginBottom: 20
    }
  };

  return (
    <>
      <div style={styles.label}>{label}</div>
      {description && <div style={styles.description}>{description}</div>}
      <div style={styles.content}>{children}</div>
    </>
  );
};

FieldGroup.propTypes = {
  action: PropTypes.node,
  contained: PropTypes.bool,
  description: PropTypes.string,
  label: PropTypes.string.isRequired
};

export default FieldGroup;